<template>
  <div class="d-flex flex-row align-stretch mb-12">
    <div>
      <user-avatar :avatar="user.avatar" size="120" tile />
    </div>
    <div class="d-flex flex-column justify-space-around ml-6">
      <v-btn
        text
        color="primary"
        class="text-capitalize"
        @click="showCropperModal = !showCropperModal"
        :loading="loading"
      >
        <v-icon left>{{icons.addImage}}</v-icon>Upload Image
      </v-btn>
      <v-btn
        v-if="user.avatar"
        text
        color="primary"
        class="text-capitalize"
        @click="deleteConfirmDialog = true"
        :loading="loading"
      >
        <v-icon left>{{icons.delete}}</v-icon>Delete Image
      </v-btn>
    </div>
    <image-cropper v-model="showCropperModal" @change="avatarChange" />
    <v-dialog v-model="deleteConfirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Logout</v-card-title>
        <v-card-text>
          <strong>Are you sure you want to logout ?</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="deleteConfirmDialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteAvatar">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">Ok</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiImagePlus, mdiDelete } from '@mdi/js'
import ImageCropper from '@/components/modals/ImageCropper'
import UserAvatar from '@/components/UserAvatar'
import User from '@/models/User'
import Publisher from '@/models/Publisher'
import Editor from '@/models/Editor'

export default {
  props: {
    user: {
      type: [User, Publisher, Editor]
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    ImageCropper, UserAvatar
  },
  data () {
    return {
      icons: {
        addImage: mdiImagePlus,
        delete: mdiDelete
      },
      showCropperModal: false,
      deleteConfirmDialog: false,
      snackbar: {
        show: false,
        message: null
      }
    }
  },
  methods: {
    avatarChange (image) {
      this.$emit('change', image)
    },
    async deleteAvatar () {
      await this.$api.delete(`/users/${this.user.id}/avatar`)
      this.showSnackbar('User avatar successfully deleted!')
      this.deleteConfirmDialog = false
      this.$emit('avatarRemove')
    },
    showSnackbar (message) {
      this.snackbar.message = message
      this.snackbar.show = true
    }
  }
}
</script>

<style>
</style>
